import type { SVGProps } from 'react';

type Props = { width?: number; height?: number; color?: string; primary_color?: string } & SVGProps<SVGSVGElement>;

export const SVG = (props: Props) => (
  <svg width={props.width} height={props.height} viewBox='0 0 27 31' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M5.78571 9.20312V9.6875H2.89286V9.20312C2.89286 4.12324 6.9971 0 12.0536 0H14.9464C20.0029 0 24.1071 4.12324 24.1071 9.20312V9.6875H21.2143V9.20312C21.2143 5.72773 18.4058 2.90625 14.9464 2.90625H12.0536C8.5942 2.90625 5.78571 5.72773 5.78571 9.20312ZM0 13.5625C0 12.4908 0.86183 11.625 1.92857 11.625H25.0714C26.1382 11.625 27 12.4908 27 13.5625C27 14.6342 26.1382 15.5 25.0714 15.5H24.7641L23.4141 28.3965C23.2574 29.8738 22.0158 31 20.5393 31H6.46071C4.97812 31 3.73661 29.8799 3.58594 28.3965L2.23594 15.5H1.92857C0.86183 15.5 0 14.6342 0 13.5625Z'
      fill={props?.primary_color || 'white'}
    />
    <path
      d='M17.8262 17.2894C18.091 16.9555 18.0488 16.4596 17.7301 16.1821C17.4113 15.9047 16.938 15.9489 16.6731 16.2828L13.5 20.2724L10.3269 16.2828C10.062 15.9489 9.58865 15.9047 9.26993 16.1821C8.95122 16.4596 8.90903 16.9555 9.17385 17.2894L12.5227 21.5L9.17385 25.7106C8.90903 26.0445 8.95122 26.5404 9.26993 26.8179C9.58865 27.0953 10.062 27.0511 10.3269 26.7172L13.5 22.7276L16.6731 26.7172C16.938 27.0511 17.4113 27.0953 17.7301 26.8179C18.0488 26.5404 18.091 26.0445 17.8262 25.7106L14.4773 21.5L17.8262 17.2894Z'
      fill={props?.color || 'black'}
    />
  </svg>
);

export default SVG;
